import React from "react";
import { TicketCancellationTemplate } from "../../Templates/TicketCancellationTemplate";

export const TicketCancellation = () => {
  return <TicketCancellationTemplate />;
};
